import { createContext, useContext } from 'react';

export interface MentionProfile {
    type: 'hermandad' | 'banda' | 'organizacion';
    id: string;
    name: string;
    escudoUrl?: string;
}

export interface SocialCtx {
    /** Modo escaparate público: no se puede interactuar. */
    publicMode: boolean;
    /**
     * Comprueba si el usuario puede interactuar. Si no (modo público), muestra
     * el aviso de "debes ser ciudadano" y devuelve false.
     */
    requireCitizen: () => boolean;
    /** Mapa `type:id` -> perfil, para resolver menciones @. */
    profiles: Map<string, MentionProfile>;
    /** Abrir el perfil social de una mención. */
    onMention: (type: 'hermandad' | 'banda' | 'organizacion', id: string) => void;
}

export const SocialContext = createContext<SocialCtx>({
    publicMode: false,
    requireCitizen: () => true,
    profiles: new Map(),
    onMention: () => {},
});

export const useSocial = () => useContext(SocialContext);
